export function setPageMetadata(title: string, description: string): void {
  document.title = title;
  let element = document.querySelector<HTMLMetaElement>(
    'meta[name="description"]',
  );
  if (!element) {
    element = document.createElement("meta");
    element.name = "description";
    document.head.appendChild(element);
  }
  element.content = description;
}
